import React from "react";
import { StatusPill, formatTime, getTypeIcon } from "./MessagesCommon";

export default function MessageRow({ msg, onOpen }) {
  // Extract recipient names dynamically from the targets array structure
  const baseTargets = msg.targets ?? [];
  const targetNames = baseTargets.map((t) => t.connector).filter(Boolean);

  // Determine descriptive summary text for the recipient line
  let recipientSummary = "";
  if (msg.recipientScope === "ALL") {
    recipientSummary = `All Active Connectors (${msg.targetCount})`;
  } else if (targetNames.length === 0) {
    recipientSummary = "Unknown Recipients";
  } else if (targetNames.length <= 3) {
    recipientSummary = targetNames.join(", ");
  } else {
    recipientSummary = `${targetNames.slice(0, 3).join(", ")} + ${targetNames.length - 3} more`;
  }

  // Check delivery conversion rates for extra visual utility context
  const deliverySummary = `(${msg.delivered}/${msg.targetCount} delivered)`;

  return (
    <div
      onClick={() => onOpen(msg)}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        padding: "14px 20px",
        borderBottom: "1px solid #f0f0f4",
        cursor: "pointer",
        background: "#fff",
        transition: "background 0.15s",
        position: "relative",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f4ff")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
    >
      {/* Type Icon Descriptor Indicator */}
      <span style={{ fontSize: "22px", flexShrink: 0, paddingTop: "2px" }}>
        {getTypeIcon(msg.messageType)}
      </span>

      <div style={{ flex: 1, minWidth: 0 }}>
        {/* Row Header Line: Recipients & Time */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: "8px" }}>
          <div style={{
            fontWeight: 600,
            fontSize: "14px",
            color: "#1a202c",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}>
            <span style={{ color: "#718096", fontWeight: 400 }}>To: </span>
            {recipientSummary}
          </div>
          <div style={{ fontSize: "12px", color: "#a0aec0", flexShrink: 0 }}>
            {formatTime(msg.createdAt)}
          </div>
        </div>

        {/* Row Subject Line */}
        <div style={{
          fontSize: "13px",
          fontWeight: 400,
          color: "#2d3748",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          marginTop: "2px"
        }}>
          {msg.subject || <em style={{ color: "#a0aec0" }}>(no subject)</em>}
        </div>

        {/* Row Bottom Metadata Pills */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px" }}>
          <StatusPill status={msg.status} direction="OUTBOX" />

          <span style={{ fontSize: "11px", color: "#4a5568", background: "#edf2f7", borderRadius: "4px", padding: "1px 6px" }}>
            {deliverySummary}
          </span>

          {msg.messageType && (
            <span style={{ fontSize: "11px", color: "#718096", background: "#f7fafc", border: "1px solid #e2e8f0", borderRadius: "4px", padding: "1px 6px" }}>
              {msg.messageType}
            </span>
          )}

          {msg.recipientScope === "ALL" && (
            <span style={{ fontSize: "11px", color: "#744210", background: "#fefcbf", border: "1px solid #f6e05e", borderRadius: "4px", padding: "1px 6px" }}>
              Global Broadcast
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
